// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

import Column from '../Column';
import { Direction } from './Tooltips';

export const S = {
  RelativeContainer: styled.div`
    position: relative;
  `,
  Container: styled(Column)<{direction: Direction}>`
    ${({ direction }) => (direction === 'topLeft' || direction === 'bottomLeft') ?
      { left: '0' } : { right: '0' }}
  `,
  TextBox: styled.div`
    font: 14px Noto Sans TC;
    letter-spacing: 0.29px;
    color: #fff;
    padding: 12px 16px;
    background: #434343;
    border-radius: 4px;
    max-width: 223px;
    position: relative;
	`,
  Triangle: styled.div<{direction: Direction}>`
    ${({ direction }) => {
      if (direction === 'topLeft' || direction === 'bottomLeft') {
        return `
          align-self: flex-start;
          margin-left: 6px;
        `
      } else {
        return `
          align-self: flex-end;
          margin-right: 6px;
        `
      }
    }}

    ${({ direction }) => {
      if (direction === 'topLeft' || direction === 'topRight') {
        return `
          border-width: 0 7px 7px 7px;
          border-color: transparent transparent #434343 transparent;
        `
      } else {
        return `
          border-width: 7px 7px 0 7px;
          border-color: #434343 transparent transparent transparent;
        `
      }
    }}

    border-radius: 1px;
    border-style: solid;
    z-index: 1;
  `
}
